"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toc = exports.title = exports.slug = exports.pageId = exports.navTitle = exports.name = exports.metaDescription = exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/
// translate-ignore

const pageId = exports.pageId = 29866937484;
const slug = exports.slug = 'guides/api/conversations/working-with-chatbots/code-snippets';
// translate-ignore
const navTitle = exports.navTitle = 'Code snippets';
const title = exports.title = 'Conversations | Running code snippets in bots';
const name = exports.name = 'vNext Docs DP - Running Code Snippets in bots';
const metaDescription = exports.metaDescription = 'Instructions and for running your own code snippets in a bot action';
const toc = exports.toc = [{
  "depth": 0,
  "id": "limitations",
  "label": "Limitations",
  "parent": null
}, {
  "depth": 0,
  "id": "available-libraries",
  "label": "Available libraries",
  "parent": null
}];
function _createMdxContent(props) {
  const _components = Object.assign({
      h1: "h1",
      p: "p",
      a: "a",
      img: "img",
      ul: "ul",
      li: "li",
      code: "code",
      pre: "pre",
      h2: "h2"
    }, (0, _react.useMDXComponents)(), props.components),
    {
      RelatedApiLink
    } = _components;
  if (!RelatedApiLink) _missingMdxReference("RelatedApiLink", true);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.h1, {
      children: "Running code snippets in bots"
    }), "\n", (0, _jsxRuntime.jsx)(RelatedApiLink, {}), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["When ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/articles/kcs_article/conversations/create-a-bot",
        children: "creating or editing a bot"
      }), ", you can add a code snippet by clicking the \"+\" to ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/articles/kcs_article/conversations/a-guide-to-bot-actions",
        children: "add an action"
      }), " as you normally would. From the action selection panel, click on \"Run a code snippet.\"", (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://developers.hubspot.com/hs-fs/hubfs/KB%20Team/run-a-code-snippet-2.png?width=322&name=run-a-code-snippet-2.png",
        alt: "run-a-code-snippet-2"
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Next, give your action a nickname. Within the code editing pane, you'll see our default template for Node.js 10.x. The details of the \"event\" object and possible response object formats are detailed below.", (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://developers.hubspot.com/hs-fs/hubfs/KB%20Team/run-a-code-snippet-editor.png?width=388&name=run-a-code-snippet-editor.png",
        alt: "run-a-code-snippet-editor"
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "The code will be triggered when the saved action is reached in a conversation."
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "There are three main things to keep in mind when working with code snippets:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["The ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "exports.main()"
        }), " function is called when the code snippet action is executed."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["The ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "event"
        }), " argument is an object containing details for the visitor and chat session."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["The ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "callback()"
        }), " function is used to pass data back to the bot and user. It should be called in the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "exports.main"
        }), " function."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["The ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "event"
      }), " object will contain the following data:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "//example payload\n{\n  \"userMessage\": {\n  // Details for the last message sent to your bot\n    \"message\": \"100-500\",\n    // The last message received by your bot, sent by the visitor\n    \"quickReply\": {\n    // If the visitor selected any quick reply options, this will be a list of the selected options.\n    // Will be 'null' if no options were selected.\n      \"quickReplies\":[\n      // A list of quick reply options selected by the visitor\n         {\n            \"value\":\"100-500\",\n            \"label\":\"100-500\"\n         }\n      ],\n  },\n  \"session\": {\n    \"vid\": 12345,\n    // The contact VID of the visitor, if known.\n    \"properties\": {\n    // A list of properties collected by the bot in the current session.\n      \"CONTACT\": {\n        \"firstname\": {\n          \"value\": \"John\",\n          \"syncedAt\": 1534362540592\n        },\n        \"email\": {\n          \"value\": \"testing@domain.com\",\n          \"syncedAt\": 1534362541764\n        },\n        \"lastname\": {\n          \"value\": \"Smith\",\n          \"syncedAt\": 1534362540592\n        }\n      }\n    },\n  \"customState\":{myCustomCounter: 1, myCustomString:\"someString\"}\n  // Only present if it customState was passed in from a previous callback payload\n  }\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["The ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "callback()"
      }), " function is used to send data back to the bot. The argument should be an object with the following data:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "//sample payload\n{\n  \"botMessage\": \"Thanks for checking out our website!\",\n  // This is the message your bot will display to the visitor.\n  \"quickReplies\": [{ value:'option',\n  // Passed to the bot as the response on click\n   label:'Option' // Gets displayed as the button label\n    }],\n  // the quickReplies object is optional\n  \"nextModuleNickname\": \"SuggestAwesomeProduct\",\n  // The nickname of the next module the bot should execute. If undefined, the bot will follow the default configured behavior\n  \"responseExpected\": false\n  // If true, the bot will display the returned botMessage, wait for a response, then execute this code snippet again with that new response.\n  \"customState\":{myCustomCounter: 1, myCustomString:\"someString\"}\n  // Optional field to pass along to the next step.\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Limitations"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Code snippets in bots must finish running within 20 seconds and only use 128 MB of memory. Exceeding either of these limits will result in an error."
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Available libraries"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Several popular Node.js libraries are available for use within the code snippet."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://www.npmjs.com/package/async",
          children: "async"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://www.npmjs.com/package/lodash",
          children: "lodash"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://www.npmjs.com/package/mongoose",
          children: "mongoose"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://www.npmjs.com/package/mysql",
          children: "mysql"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://www.npmjs.com/package/redis",
          children: "redis"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://www.npmjs.com/package/request",
          children: "request"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://www.npmjs.com/package/aws-sdk",
          children: "aws-sdk"
        })
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["The libraries can be loaded using the normal ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "require()"
      }), " function at the top of your code."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "const request = require('request');\n\nexports.main = (event, callback) => {\n  request('http://time.jsontest.com/', function (error, response, body) {\n    const responseJson = {\n      botMessage: 'The current time in GMT is ' + JSON.parse(body).time,\n      responseExpected: false,\n    };\n\n    callback(responseJson);\n  });\n};\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}